// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-7bc26d5c]:not(:hover){color:inherit}.tag-button[data-v-7bc26d5c]{display:inline-block;margin-right:6px;margin-bottom:6px;padding:4px 16px;border:1px solid #e0e0e0;border-radius:2em;cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
